/* eslint-disable react/prop-types */
import React from 'react'
import { MenuItem, Box, FormControl, Select, InputAdornment, CircularProgress } from '@mui/material'
import { Sort } from '@mui/icons-material'
const levelOrder = ['CHALLENGER', 'GRANDMASTER', 'MASTER', 'DIAMOND', 'PLATINUM', 'GOLD', 'SILVER', 'BRONZE', 'IRON', 0]

export const sortChallenges = (challenges) => {
  return challenges.sort((a, b) => {
    const levelComparison = levelOrder.indexOf(a.level) - levelOrder.indexOf(b.level)
    if (levelComparison !== 0) return levelComparison

    return b.percentage - a.percentage
  })
}

export const getNextLevelRewards = (currentLevel, challengeId) => {
  const levelIndex = levelOrder.indexOf(currentLevel)
  if (levelIndex <= 2 || (challengeId === 101206 && currentLevel === 'BRONZE') || (challengeId === 101102 && currentLevel === 'MASTER')) return null // MASTER+ do not show rewards
  if (challengeId === 101102 && currentLevel === 'IRON') return '100 capstone progress'

  const nextLevel = levelOrder[levelIndex]
  switch (nextLevel) {
    case 'DIAMOND':
      return '40 capstone progress'
    case 'PLATINUM':
      return '20 capstone progress'
    case 'GOLD':
      return '15 capstone progress'
    case 'SILVER':
      return '10 capstone progress'
    case 'BRONZE':
      return '5 capstone progress'
    case 'IRON':
      return '10 capstone progress'
    default:
      return null
  }
}

export const Gauge = ({ value, imageSrc, type, champion, size = 80 }) => {
  const getColor = (value) => {
    return value >= 0.75 ? 'green' : value >= 0.5 ? 'orange' : 'red'
  }

  const adjustedValue = value || 0
  const getImageTitle = (champion, type) => {
    if (!champion) return ''
    const { championName, championPoints, tokensEarned, championPointsUntilNextLevel } = champion
    return `${championName}: ${championPoints} points, ${Math.max(championPointsUntilNextLevel, 0)} points for next level${type === 'highLevel' ? `, ${tokensEarned} ${tokensEarned === 1 ? 'token' : 'tokens'}` : ''}`
  }

  return (
    <Box position="relative" display="inline-flex" alignItems="center">
      <CircularProgress
        variant="determinate"
        value={adjustedValue}
        thickness={10}
        size={size}
        style={{
          color: getColor(value / 100),
          transition: 'all 0.5s ease-out'
        }}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <img src={imageSrc} alt="" style={{ width: '68px', height: '68px', borderRadius: '100%' }} title={getImageTitle(champion, type)} />
      </Box>
    </Box>
  )
}

export const CategorySelect = ({ categoryOption, handleCategoryChange, challengeCategories }) => {
  return (
    <FormControl sx={{ minWidth: 200 }}>
      <Select
        labelId="category-select-label"
        id="category-select"
        value={categoryOption}
        onChange={handleCategoryChange}
        displayEmpty
        sx={{ backgroundColor: '#fff', borderRadius: '4px', boxShadow: 3, color: '#000' }}
        startAdornment={
          <InputAdornment position="start">
            <Sort sx={{ color: '#00bfff' }} />
          </InputAdornment>
        }
        MenuProps={{
          PaperProps: {
            sx: { backgroundColor: '#fff', borderRadius: '4px', boxShadow: 3 }
          }
        }}
      >
        <MenuItem value="">
          <em>All Categories</em>
        </MenuItem>
        {Object.keys(challengeCategories).map((category) => (
          <MenuItem value={category} key={category}>
            {category}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
